import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaTrashAlt } from "react-icons/fa";
import Swal from "sweetalert2";
import './capture.css'
import CustomSelect from "./custom-select";


function CaptureForm({ onSuccess, masterData }) {
    const [loadType, setLoadType] = useState("Directa"); // Estado del select
    const [rows, setRows] = useState([]); // Estado de las filas
    const [initialOrigin, setInitialOrigin] = useState("");
    const [origin, setOrigin] = useState("");
    const [destiny, setDestiny] = useState("");
    const [finalDestiny, setFinalDestiny] = useState("");
    const [masterPieces, setMasterPieces] = useState("");
    const [masterWeight, setMasterWeight] = useState("");
    const [merchandiseType, setMerchandiseType] = useState("");
    const [chargeableWeight, setChargeableWeight] = useState("");
    const [masterTotalVol, setMasterTotalVol] = useState("");
    const [description, setDescription] = useState("");
    const [declaredValue, setDeclaredValue] = useState("");
    const [motion, setMotion] = useState("");
    const [key, setKey] = useState("");
    const [customsBadge, setCustomsBadge] = useState("");
    const [deliverName, setDeliverName] = useState("");
    const [errors, setErrors] = useState({});
    const [rowErrors, setRowErrors] = useState('');   // Guardar error cuando no hay ninguna fila en la tabla de consolidada o parcial
    const [rowFieldErrors, setRowFieldErrors] = useState([]);    // guardar errores de campos obligatorios en estas filas
    const [agents, setAgents] = useState([]);
    const [coin, setCoin] = useState([]);
    const [totalPiezasHouses, setTotalPiezasHouses] = useState(0);
    const [totalVolumenHouses, setTotalVolumenHouses] = useState(0);
    const [totalPesoHouses, setTotalPesoHouses] = useState(0);
    const [totalCWHouses, setTotalCWHouses] = useState(0);
    const [errorPesoPiezas, setErrorPesoPiezas] = useState(false);
    //para los selects
    const [forwardingAgent, setForwardingAgent] = useState('');
    const [forwardingConsignee, setForwardingConsignee] = useState('');
    const [forwardingShipper, setForwardingShipper] = useState('');
    const [updateMoment, setUpdateMoment] = useState(false);
    const [closeMaster, setCloseMaster] = useState(false);
    const [isBadgeLocked, setIsBadgeLocked] = useState(false);
    const shippers = masterData.data.shippers_catalog;
    const consigners = masterData.data.consignees_catalog;



    // Agregar una nueva fila
    const addRow = () => {
        setRows([...rows, { hbs: "", piezas: "", grossWeight: "", chargeableWeight: "", volumen: "", tipoMercancia: "", descripcion: "" }]);
    };

    // Eliminar una fila por índice
    const removeRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);
    };

    const isInteger = (value) => /^\d+$/.test(value);
    const isDecimalUpTo4 = (value) => /^\d*(\.\d{0,4})?$/.test(value);

    const handleInputChange = (e, setter, field) => {
        let { value } = e.target;
        
        const only3LetterFields = ["initialOrigin", "origin", "destiny", "finalDestiny"];
        const decimalFields = ["masterWeight", "chargeableWeight", "masterTotalVol"];

        if (only3LetterFields.includes(field)) {
            value = value
                .toUpperCase()              // Mayúsculas
                .replace(/[^A-Z]/g, '')     // Solo letras
                .slice(0, 3);               // Máximo 3 caracteres
        } else if (field === "masterPieces") {
            value = value.replace(/[^0-9]/g, '');
        } else if (decimalFields.includes(field)) {
            value = value.replace(/[^0-9.]/g, '');
    
            // Evitar más de un punto decimal
            const parts = value.split('.');
            if (parts.length > 2) {
                parts.splice(2); // quita cualquier extra
            }
    
            if (parts[1]) {
                parts[1] = parts[1].slice(0, 4);
            }
    
            value = parts.join('.');
        }

        setter(value);
    
        // Si había un error en este campo, lo eliminamos cuando el usuario escriba
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors[field];
            return newErrors;
        });
    };

    const validateForm = () => {
        let newErrors = {};
        
        if (!initialOrigin) newErrors.initialOrigin = "Este campo es obligatorio";
        if (!origin) newErrors.origin = "Este campo es obligatorio";
        if (!destiny) newErrors.destiny = "Este campo es obligatorio";
        if (!finalDestiny) newErrors.finalDestiny = "Este campo es obligatorio";
        if (!masterPieces) newErrors.masterPieces = "Este campo es obligatorio";
        if (!masterWeight) newErrors.masterWeight = "Este campo es obligatorio";
        if (!merchandiseType) newErrors.merchandiseType = "Este campo es obligatorio";
        if (!chargeableWeight) newErrors.chargeableWeight = "Este campo es obligatorio";
        if (!masterTotalVol) newErrors.masterTotalVol = "Este campo es obligatorio";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Retorna `true` si no hay errores
    };

    const validateRows = () => {
        const errors = [];
        
        if (loadType === "Consolidada" || loadType === "Parcial" || loadType == 2 || loadType == 3) {
            setErrorPesoPiezas(false); 
            if (rows.length === 0) {
                setRowErrors("Introduce al menos una fila en la tabla.");
                setRowFieldErrors([]); // sin errores por fila
                return false;
            }
    
            let allValid = true;
            const rowError = {};
            rows.forEach((row, index) => {
                if (!row.hbs) rowError.hbs = true;
                if (!row.piezas) rowError.piezas = true;
                if (!row.grossWeight) rowError.grossWeight = true;
                if (!row.chargeableWeight) rowError.chargeableWeight = true;
                if (!row.volumen) rowError.volumen = true;
                if (!row.tipoMercancia) rowError.tipoMercancia = true;
    
                if (Object.keys(rowError).length > 0) {
                    allValid = false;
                }
    
                errors[index] = rowError;
                
            });
            
            if(totalPiezasHouses != parseFloat(masterPieces).toFixed(2)){ 
                setErrorPesoPiezas(true); 
                rowError.piezas_total = true; 
                allValid = false;
            }

            if(totalVolumenHouses != parseFloat(masterTotalVol).toFixed(2)){ 
                setErrorPesoPiezas(true); 
                rowError.piezas_total = true; 
                allValid = false;
            }

            if(totalPesoHouses != parseFloat(masterWeight).toFixed(2)){ 
                setErrorPesoPiezas(true); 
                rowError.piezas_total = true; 
                allValid = false;
            }

            if(totalCWHouses != parseFloat(chargeableWeight).toFixed(2)){ 
                setErrorPesoPiezas(true); 
                rowError.piezas_total = true; 
                allValid = false;
            }
            setRowFieldErrors(errors);
            setRowErrors(""); // Limpiar error general
            return allValid;
        }
    
        setRowFieldErrors([]); // No se aplica
        setRowErrors("");
        return true;
    };

    const handleCloseMaster = async () => {
        let newErrors = {};

        if (!initialOrigin) newErrors.initialOrigin = "Este campo es obligatorio";
        if (!origin) newErrors.origin = "Este campo es obligatorio";
        if (!destiny) newErrors.destiny = "Este campo es obligatorio";
        if (!finalDestiny) newErrors.finalDestiny = "Este campo es obligatorio";
        if (!masterPieces) newErrors.masterPieces = "Este campo es obligatorio";
        if (!masterWeight) newErrors.masterWeight = "Este campo es obligatorio";
        if (!merchandiseType) newErrors.merchandiseType = "Este campo es obligatorio";
        if (!chargeableWeight) newErrors.chargeableWeight = "Este campo es obligatorio";
        if (!masterTotalVol) newErrors.masterTotalVol = "Este campo es obligatorio";
        if (!description) newErrors.description = "Este campo es obligatorio"
        if (!forwardingShipper) newErrors.forwardingShipper = "Este campo es obligatorio"
        if (!forwardingConsignee) newErrors.forwardingConsignee = "Este campo es obligatorio"
        if (!forwardingAgent) newErrors.forwardingAgent = "Este campo es obligatorio"
        if (!coin) newErrors.coin = "Este campo es obligatorio"
        if (!declaredValue) newErrors.declaredValue = "Este campo es obligatorio"
        if (!motion) newErrors.motion = "Este campo es obligatorio"
        if (!key) newErrors.key = "Este campo es obligatorio"
        if (!customsBadge) newErrors.customsBadge = "Este campo es obligatorio"
        if (!deliverName) newErrors.deliverName = "Este campo es obligatorio"

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            setCloseMaster(true);
            return;
        }
        Swal.fire("Error", "Debe llenar toda la información para cerrar la master", "error");
        return false;
    };

    const handleSave = async () => {
        const isMainFormValid = validateForm();
        const areRowsValid = validateRows(); // validamos la tabla

        if (isMainFormValid && areRowsValid) {
            const userData = localStorage.getItem('user');
            const user = JSON.parse(userData);
           
            try {
                //vamos a recoger todos los valores
                let master = masterData.data.master;
                let origin = document.getElementById('initialOrigin')?.value || '';
                let destiny = document.getElementById('destiny')?.value || '';
                let final_origin = document.getElementById('origin')?.value || '';
                let final_destination = document.getElementById('finalDestiny')?.value || '';
                let masterPieces = document.getElementById('masterPieces')?.value || '';
                let masterWeight = document.getElementById('masterWeight')?.value || '';
                let masterTotalVol = document.getElementById('masterTotalVol')?.value || '';
                let description = document.getElementById('description')?.value || '';
                let merchandiseType = document.getElementById('merchandiseType')?.value || '';
                let chargeableWeight = document.getElementById('chargeableWeight')?.value || '';
                let loadType = document.getElementById('loadType')?.value || '';
                let shipper = document.getElementById('shipper_id')?.value || '';
                let Consignatario = document.getElementById('consignee_id')?.value || '';
                let forwardingAgentText = document.getElementById('agent_id')?.selectedOptions[0]?.text || '';
                let coin = document.getElementById('coin')?.value || '';
                let motion = document.getElementById('motion')?.value || '';
                let key = document.getElementById('key')?.value || '';
                let customsBadge = document.getElementById('customsBadge')?.value || '';
                let declaredValue = document.getElementById('declaredValue')?.value || '';
                let deliverName = document.getElementById('deliverName')?.value || '';
                // Obtener múltiples campos con clase
                let hbs_hbs = Array.from(document.querySelectorAll('.hbs_hbs'))
                .map(el => el.value)
                .filter(val => val !== '');
                let hbs_pieces = Array.from(document.querySelectorAll('.hbs_pieces')).map(el => el.value);
                let hbs_grossweight = Array.from(document.querySelectorAll('.hbs_grossweight')).map(el => el.value);
                let hbs_chargeableweight = Array.from(document.querySelectorAll('.hbs_chargeableweight')).map(el => el.value);
                let hbs_volume = Array.from(document.querySelectorAll('.hbs_volume')).map(el => el.value);
                let hbs_merchandiseType = Array.from(document.querySelectorAll('.hbs_merchandiseType')).map(el => el.value);
                let hbs_description = Array.from(document.querySelectorAll('.hbs_description')).map(el => el.value);


                // Armar el objeto
                
                if(!updateMoment){
                    let data = {
                      origin,
                      destination: destiny,
                      final_origin,
                      final_destination,
                      master_pieces: masterPieces,
                      master_weight: masterWeight,
                      volume: masterTotalVol,
                      description,
                      merchandise_type: merchandiseType,
                      chargeable_weight: chargeableWeight,
                      entry_type: loadType,
                      user_id:1,  //user.id,
                      master,
                      shipper_id: forwardingShipper,
                      consignee_id: forwardingConsignee,
                      agent_id: forwardingAgent,
                      currency: coin,
                      pediment: motion,
                      key,
                      customs_badge: customsBadge,
                      deliver_name: deliverName,
                      h_id: hbs_hbs,
                      h_hbs: hbs_hbs,
                      h_pieces: hbs_pieces,
                      h_gross_weight: hbs_grossweight,
                      h_chargeable_weight: hbs_chargeableweight,
                      h_volume: hbs_volume,
                      h_merchandise_type: hbs_merchandiseType,
                      h_description: hbs_description,
                      decalred_value: declaredValue,
                      is_closed: closeMaster ? 1 : 0
                    };
                    let res = await axios.post(
                        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_capture/saveNewCapture`,
                        data,{
                            headers: {
                                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                                'Content-Type': 'application/json'
                            },
                        }
                    );
                    if (res.data.code == 1) {
                        //console.log(res.data)
                        // console.log("onSuccess en handleSave:", onSuccess);
                        Swal.fire("Éxito", "Datos guardados correctamente", "success").then(() => {
                            onSuccess(master);
                        });
                    }else{
                        //console.log(res.data, 'error')
                        Swal.fire("Error", "Master no encontrada, favor de verificar", "error");
                    }
                }else{
                    let data = {
                      origin,
                      destination: destiny,
                      final_origin,
                      final_destination,
                      master_pieces: masterPieces,
                      master_weight: masterWeight,
                      volume: masterTotalVol,
                      description,
                      merchandise_type: merchandiseType,
                      chargeable_weight: chargeableWeight,
                      entry_type: loadType,
                      user_id: 1,  // user.id,
                      master,
                      shipper_id: forwardingShipper,
                      consignee_id: forwardingConsignee,
                      agent_id: forwardingAgent,
                      currency: coin,
                      pediment: motion,
                      key,
                      customs_badge: customsBadge,
                      deliver_name: deliverName,
                      h_id: hbs_hbs,
                      h_hbs: hbs_hbs,
                      h_pieces: hbs_pieces,
                      h_gross_weight: hbs_grossweight,
                      h_chargeable_weight: hbs_chargeableweight,
                      h_volume: hbs_volume,
                      h_merchandise_type: hbs_merchandiseType,
                      h_description: hbs_description,
                      decalred_value: declaredValue,
                      master_id: masterData.data.resp.id,
                      is_closed: closeMaster ? 1 : 0
                    };
                    let res = await axios.post(
                        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_capture/saveCapture`,
                        data,{
                            headers: {
                                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                                'Content-Type': 'application/json'
                            },
                        }
                    );
                    if (res.data.code == 1) {
                        Swal.fire("Éxito", "Datos guardados correctamente", "success").then(() => {
                            onSuccess(master);
                        });
                    }else{
                        Swal.fire("Error", "Master no encontrada, favor de verificar", "error");
                    }
                }
                

                
            } catch (error) {
                console.log(error)
              Swal.fire("Error", "Error. Intente nuevamente", "error");
            }
            // Aquí iría la lógica para guardar los datos
        } else {
            Swal.fire("Error", "Error. Verifique la información", "error");
        }
    };

    

    const getAgents = async () => {
        try {
          const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/agents`, {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          });
          if (res.data.code === 1) {
            setAgents(res.data.data);
          } else {
            Swal.fire("Error", "Hubo un error al obtener los datos", "error");
          }
        } catch (error) {
          Swal.fire("Error", "Hubo un error al obtener los datos", "error");
        }
    }; 

    const formatToSixDecimals = (value) => {
        // Si el valor es nulo, indefinido o la cadena vacía, devuelve cadena vacía
        if (!value) return ''; 
        
        // Si es un string, lo parseamos y luego lo formateamos.
        const num = parseFloat(value);
        
        // Si el número es 0, puedes devolver '0.000000' o '0' para evitar la mala visualización.
        if (num === 0) return '0.000000'; 
        
        // Devolvemos el número formateado con 6 decimales
        return num.toFixed(6); 
    };

    useEffect(() => {
        getAgents();
        if(masterData.data.resp != null){
            setUpdateMoment(true);
            if (masterData?.data?.resp?.dest != null) setDestiny(masterData.data.resp.dest);
            if (masterData?.data?.resp?.final_dest != null) setFinalDestiny(masterData.data.resp.final_dest);
            if (masterData?.data?.resp?.orig != null) setInitialOrigin(masterData.data.resp.orig);
            if (masterData?.data?.resp?.final_orig != null) setOrigin(masterData.data.resp.final_orig);
            if (masterData?.data?.resp?.pieces != null) setMasterPieces(masterData.data.resp.pieces);
            if (masterData?.data?.resp?.weigth != null) setMasterWeight(masterData.data.resp.weigth);
            if (masterData?.data?.resp?.merchandise != null) setMerchandiseType(masterData.data.resp.merchandise);
            if (masterData?.data?.resp?.chargeable_weight != null) setChargeableWeight(masterData.data.resp.chargeable_weight);
            if (masterData?.data?.resp?.volume != null) setMasterTotalVol(masterData.data.resp.volume);
            if (masterData?.data?.resp?.description != null) setDescription(masterData.data.resp.description);

            if (masterData?.data?.exp_assig?.value != null) setDeclaredValue(masterData.data.exp_assig.value);
            if (masterData?.data?.exp_assig?.pediment != null) setMotion(masterData.data.exp_assig.pediment);
            if (masterData?.data?.exp_assig?.clave != null) setKey(masterData.data.exp_assig.clave);
            if (masterData?.data?.exp_assig?.id_currency != null) setCoin(masterData.data.exp_assig.id_currency);
            if (masterData?.data?.exp_assig?.id_agency != null) setForwardingAgent(masterData.data.exp_assig.id_agency);

            if (masterData?.data?.badge?.number != null) setCustomsBadge(masterData.data.badge.number);
            if (masterData?.data?.badge?.name != null) setDeliverName(masterData.data.badge.name);

            if (masterData?.data?.consignee?.id != null) setForwardingConsignee(masterData.data.consignee.id);
            if (masterData?.data?.shipper?.id != null) setForwardingShipper(masterData.data.shipper.id);

            if (masterData?.data?.badge?.number != null && masterData?.data?.badge?.name != null) setIsBadgeLocked(true);

            if(masterData.data.is_consolidated == 1){
                setLoadType("2");
                setRows([]);
                let houseRows = masterData.data.allHouses.map((house) => ({
                  hbs: house.hbs || "",
                  piezas: house.pieces || "",
                  grossWeight: house.gross_weight || "",
                  chargeableWeight: house.chargeable_weight || "",
                  volumen: house.volume || "",
                  tipoMercancia: house.merchandise_type_id || "",
                  descripcion: house.description || "",
                }));
                let totalPiezas = 0;
                let totalBruto = 0;
                let totalCobrable = 0;
                let totalVolumen = 0;
                houseRows.forEach((row) => {
                    let p = parseFloat(row.piezas);
                    let g = parseFloat(row.grossWeight);
                    let c = parseFloat(row.chargeableWeight);
                    let v = parseFloat(row.volumen);
                    totalPiezas += isNaN(p) ? 0 : p;
                    totalBruto += isNaN(g) ? 0 : g;
                    totalCobrable += isNaN(c) ? 0 : c;
                    totalVolumen += isNaN(v) ? 0 : v;
                });
                setTotalPiezasHouses(totalPiezas);
                setTotalPesoHouses(totalBruto);
                setTotalCWHouses(totalCobrable);
                setTotalVolumenHouses(totalVolumen);

                setRows([...rows, ...houseRows]);
            }else if(masterData.data.is_direct == 1){
                setLoadType("1");
            }else{
                setLoadType("3");
                setRows([]);
                let houseRows = masterData.data.allHouses.map((house) => ({
                  hbs: house.hbs || "",
                  piezas: house.pieces || "",
                  grossWeight: house.gross_weight || "",
                  chargeableWeight: house.chargeable_weight || "",
                  volumen: house.volume || "",
                  tipoMercancia: house.merchandise_type_id || "",
                  descripcion: house.description || "",
                }));

                let totalPiezas = 0;
                let totalBruto = 0;
                let totalCobrable = 0;
                let totalVolumen = 0;
                houseRows.forEach((row) => {
                    let p = parseFloat(row.piezas);
                    let g = parseFloat(row.grossWeight);
                    let c = parseFloat(row.chargeableWeight);
                    let v = parseFloat(row.volumen);
                    totalPiezas += isNaN(p) ? 0 : p;
                    totalBruto += isNaN(g) ? 0 : g;
                    totalCobrable += isNaN(c) ? 0 : c;
                    totalVolumen += isNaN(v) ? 0 : v;
                });
                setTotalPiezasHouses(totalPiezas);
                setTotalPesoHouses(totalBruto);
                setTotalCWHouses(totalCobrable);
                setTotalVolumenHouses(totalVolumen);

                setRows([...rows, ...houseRows]);
            }
        }
        if(masterData.data.resp == null){
            if(masterData.data.sky != null){

                setInitialOrigin(masterData.data.sky.origin);
                setOrigin(masterData.data.sky.origin);
                setDestiny(masterData.data.sky.destination);
                setFinalDestiny(masterData.data.sky.destination);
                setMasterPieces(masterData.data.sky.pieces);
                setMasterWeight(masterData.data.sky.weigth);
                setChargeableWeight(masterData.data.sky.weigth);
            }
        }
    }, []);

    const createAgent = async () => {
        try {
            const result = await Swal.fire({
                title: "Registrar agente",
                html:
                '<div class="form-grid">' +
                '<input type="text" id="name" class="swal2-input" placeholder="Nombre">' +
                '<input type="text" id="code" class="swal2-input" placeholder="Código">' +
                "</div>",
                showDenyButton: true,
                confirmButtonText: "Crear",
                denyButtonText: "Cancelar",
                padding: "1px",
                color: "#000",
                backdrop: `
                    rgba(0,0,0,0.8)
                `,
                customClass: {
                    confirmButton: "btn-amc-blue",
                    denyButton: "btn-cancel",
                    title: "alert-title",
                    popup: "alert-bg",
                },
                preConfirm: function () {
                    const name = document.getElementById("name").value;
                    const code = document.getElementById("code").value;
            
                    if (!name || !code) {
                        Swal.showValidationMessage("Todos los campos son obligatorios");
                        return false;
                    }
            
                    return {
                        name,
                        code
                    };
                },
            });
      
            if (result.isConfirmed) {
                const userData = result.value;
        
                /* const response = await axios.post(
                    `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/agents/store`, userData,
                    {
                        headers: {
                            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                        },
                    }
                ); */
      
                Swal.fire(
                "¡Creado!",
                "El agente ha sido registrado exitosamente.",
                "success"
                );
                // setUpdateTrigger(!updateTrigger);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Cancelado", "Acción cancelada.", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Hubo un error", "error");
        }
      };

    useEffect(() => {
        if (closeMaster) {
          handleSave();
        }
      }, [closeMaster]);

    const SearchBadge = async (value) =>{
        try {
          const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/exp_capture/findAgent`, {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
            params: {
                badge: value,  // <-- Aquí envías el valor como query param
            },
          });
          if (res.data.code === 1 && res.data.data != null) {
            setDeliverName(res.data.data.name);
            setIsBadgeLocked(true);
          } else {
            setDeliverName('');
            setIsBadgeLocked(false);
          }
        } catch (error) {
          console.log(error);
        }
    }

    return(
        <>
            <div className="container-fluid">
            {/*Main*/}
                {!masterData?.data?.resp?.awb && (
                  <div className="alert alert-warning text-center" role="alert">
                    ¡La guía <b>{masterData?.data?.master}</b> no existe!, para el caso de parcialidades se puede registrar en el formulario, de lo contrario, verificar en skychain el envío de los archivos FWB y FHL (de ser necesario)
                  </div>
                )}
            
                <div classname="row">
                    <div className="col">
                        <label for="loadType" class="amc-label">Master</label>
                        <p style={{marginTop: '-10px'}}>{masterData.data.master} </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <label for="loadType" class="amc-label">*Tipo de carga</label>
                        <select id="loadType" class="form-select" value={loadType} onChange={(e) => setLoadType(e.target.value)}>
                            <option value="1">Directa</option>
                            <option value="2">Consolidada</option>
                            <option value="3">Parcial</option>
                        </select>
                    </div>
                    <div className="col-4">
                        <label for="initialOrigin" class="amc-label">*Origen Inicial</label>
                        <input type="text" class="form-control" id="initialOrigin" value={initialOrigin} onChange={(e) => handleInputChange(e, setInitialOrigin, "initialOrigin")} />
                        {errors.initialOrigin && <small className="text-danger">{errors.initialOrigin}</small>}
                    </div>
                    <div className="col-4">
                        <label for="origin" class="amc-label">*Origen</label>
                        <input type="text" class="form-control" id="origin" value={origin} onChange={(e) => handleInputChange(e, setOrigin, "origin")} />
                        {errors.origin && <small className="text-danger">{errors.origin}</small>}
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <label for="destiny" class="amc-label">*Destino</label>
                        <input type="text" class="form-control" id="destiny" value={destiny} onChange={(e) => handleInputChange(e, setDestiny, "destiny")} />
                        {errors.destiny && <small className="text-danger">{errors.destiny}</small>}
                    </div>
                    <div className="col-4">
                        <label for="finalDestiny" class="amc-label">*Destino final</label>
                        <input type="text" class="form-control" id="finalDestiny" value={finalDestiny} onChange={(e) => handleInputChange(e, setFinalDestiny, "finalDestiny")} />
                        {errors.finalDestiny && <small className="text-danger">{errors.finalDestiny}</small>}
                    </div>
                    <div className="col-4">
                        <label for="masterPieces" class="amc-label">*Piezas master</label>
                        <input type="text" class="form-control" id="masterPieces" value={masterPieces} onChange={(e) => handleInputChange(e, setMasterPieces, "masterPieces")} />
                        {errors.masterPieces && <small className="text-danger">{errors.masterPieces}</small>}
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <label for="masterWeight" class="amc-label">*Peso master</label>
                        <input type="text" class="form-control" id="masterWeight" value={masterWeight} onChange={(e) => handleInputChange(e, setMasterWeight, "masterWeight")} />
                        {errors.masterWeight && <small className="text-danger">{errors.masterWeight}</small>}
                    </div>
                    <div className="col-4">
                        <label for="merchandiseType" class="amc-label">*Tipo de mercancia</label>
                        <select id="merchandiseType" class="form-select" value={merchandiseType} onChange={(e) => handleInputChange(e, setMerchandiseType, "merchandiseType")} >
                            <option selected>Selecciona...</option>
                              {Array.isArray(masterData?.data?.merch_type_con)
                                ? masterData.data.merch_type_con.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.name}
                                    </option>
                                  ))
                                : Object.entries(masterData?.data?.merch_type_con || {}).map(([key, label]) => (
                                    <option key={key} value={key}>
                                      {label}
                                    </option>
                                  ))}
                        </select>
                        
                        {errors.merchandiseType && <small className="text-danger">{errors.merchandiseType}</small>}
                    </div>
                    <div className="col-4">
                        <label for="chargeableWeight" class="amc-label">*Chargeable Weight total Master</label>
                        <input type="text" class="form-control" id="chargeableWeight" value={chargeableWeight} onChange={(e) => handleInputChange(e, setChargeableWeight, "chargeableWeight")} />
                        {errors.chargeableWeight && <small className="text-danger">{errors.chargeableWeight}</small>}
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <label for="masterTotalVol" class="amc-label">*Volumén total Master</label>
                        <input type="text" class="form-control" id="masterTotalVol" value={masterTotalVol} onChange={(e) => handleInputChange(e, setMasterTotalVol, "masterTotalVol")} />
                        {errors.masterTotalVol && <small className="text-danger">{errors.masterTotalVol}</small>}
                    </div>
                    <div className="col-4">
                        <label for="description" class="amc-label">Descripción</label>
                        <input type="text" class="form-control" id="description" value={description}
                        onChange={(e) => setDescription(e.target.value)}/>
                    </div>
                    <div className="col-4">
                        <CustomSelect label="Remitente" options={shippers} labelKey="name"
                            value={shippers.find((s) => s.id === forwardingShipper) || null}
                            onSelect={(selectedShipper) => {
                                setForwardingShipper(selectedShipper?.id || '');
                            }} 
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        
                        <CustomSelect
                          label="Consignatario"
                          options={consigners}
                          labelKey="name"
                          value={consigners.find((s) => String(s.id) === String(forwardingConsignee)) || null}
                          onSelect={(selectedConsigner) => {
                            setForwardingConsignee(selectedConsigner?.id || '');
                          }}
                        />
                    </div>
                    <div className="col-4">
                        {/* <label for="forwardingAgent" className="amc-label">Agente aduanal</label>
                        <select id="forwardingAgent" class="form-select">
                            <option selected>Selecciona una opción</option>
                            <option>Agente 1</option>
                            <option>Agente 2</option>
                            <option>Agente 3</option>
                            <option>Agente 4</option>
                            <option>Agente 5</option>
                            <option>Agente 6</option>
                        </select> */}

                        {/* <select className="form-select" id="forwardingAgent" >
                            <option selected>Selecciona una opción</option>
                            {agents.map((agent) => (
                                <option key={agent.id} value={agent.id}>
                                    {agent.name}
                                </option>
                            ))}
                        </select> */}
                        <CustomSelect
                          label="Agente Aduanal"
                          options={agents}
                          labelKey="name"
                          value={agents.find((s) => String(s.id) === String(forwardingAgent)) || null}
                          onSelect={(selectedAgent) => {
                            setForwardingAgent(selectedAgent?.id || '');
                          }}
                        />
                        <p className="form-link" onClick={createAgent} >Agregar agente aduanal</p>
                    </div>
                    <div className="col-4">
                        <label for="coin" class="amc-label">Moneda</label>
                        <select id="coin" class="form-select" 
                        value={coin}
                          onChange={(e) => setCoin(e.target.value)}>
                            <option value="2">USD</option>
                            <option value="1">MXN</option>
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <label for="declaredValue" class="amc-label">Valor declarado</label>
                        <input type="text" class="form-control" id="declaredValue" value={declaredValue}
                        onChange={(e) => setDeclaredValue(e.target.value)}/>
                    </div>
                    <div className="col-4">
                        <label for="motion" class="amc-label">Pedimento</label>
                        <input type="text" class="form-control" id="motion" value={motion}
                        onChange={(e) => setMotion(e.target.value)}/>
                    </div>
                    <div className="col-4">
                        <label for="key" class="amc-label">Clave</label>
                        <input type="text" class="form-control" id="key" value={key}
                        onChange={(e) => setKey(e.target.value)}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <label for="customsBadge" class="amc-label">Persona que entrega embarque</label>
                        <input
                          type="text"
                          className="form-control"
                          id="customsBadge"
                          value={customsBadge}
                          onChange={(e) => {
                            const value = e.target.value;
                            setCustomsBadge(value);
                            SearchBadge(value); // puedes controlar el estado dentro de esta función si quieres
                          }}
                          placeholder="Gafete Aduana"
                        />
                    </div>
                    <div className="col-4">
                        <label for="deliverName" class="amc-label">&nbsp;</label>
                        <input type="text" class="form-control" id="deliverName" value={deliverName} 
                            onChange={(e) => setDeliverName(e.target.value)}
                            placeholder="Nombre"
                            readOnly={deliverName !== "" && deliverName !== null}
                            readOnly={isBadgeLocked}
                        />
                    </div>
                </div>
            {/*main*/}
                {/* Mostrar tabla solo si se selecciona Consolidada o Parcial */}
                {(loadType === "2" || loadType === "3") && (
                    <div className="mt-4">
                        <table className="table-capture">
                            <thead>
                                <tr>
                                    <th>*HBS</th>
                                    <th>*Piezas</th>
                                    <th>*Gross Weight</th>
                                    <th>*Chargeable Weight</th>
                                    <th>*Volumen</th>
                                    <th>*Tipo de mercancía</th>
                                    <th>Descripción</th>
                                    <th>Eliminar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, index) => (
                                    <tr key={index}>
                                        <td>
                                            <input type="text" className="form-control hbs_hbs" value={row.hbs} 
                                                onChange={(e) => {
                                                    const updatedRows = [...rows];
                                                    updatedRows[index].hbs = e.target.value;
                                                    setRows(updatedRows);
                                                }} 
                                            />
                                            {rowFieldErrors[index]?.hbs && <small className="text-danger">Campo obligatorio</small>}
                                        </td>
                                        <td>
                                            <input type="text" className="form-control hbs_pieces" value={row.piezas} 
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    if (newValue === '' || isInteger(newValue)) {
                                                        const updatedRows = [...rows];
                                                        updatedRows[index].piezas = newValue;
                                                        setRows(updatedRows);

                                                        const suma = updatedRows.reduce((acc, r) => acc + (parseInt(r.piezas) || 0), 0);
                                                        setTotalPiezasHouses(suma);
                                                    }
                                                }} 
                                            />
                                            {rowFieldErrors[index]?.piezas && <small className="text-danger">Campo obligatorio</small>}
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                step="any"
                                                className="form-control hbs_grossweight"
                                                value={row.grossWeight}
                                                onChange={(e) => {
                                                  const newValue = e.target.value;
                                                  const updatedRows = rows.map((r, i) =>
                                                    i === index ? { ...r, grossWeight: newValue } : r
                                                  );
                                                  setRows(updatedRows);

                                                  let grossWeight = updatedRows.reduce((acc, r) => acc + (parseFloat(r.grossWeight) || 0), 0);
                                                  grossWeight = grossWeight.toFixed(2);
                                                  setTotalPesoHouses(grossWeight);
                                                }}
                                              />
                                            {rowFieldErrors[index]?.grossWeight && <small className="text-danger">Campo obligatorio</small>}
                                        </td>
                                        <td>
                                           <input
                                             type="number"
                                             step="any"
                                             className="form-control hbs_chargeableweight"
                                             value={row.chargeableWeight}
                                             onChange={(e) => {
                                               const newValue = e.target.value;
                                               const updatedRows = [...rows];
                                               updatedRows[index].chargeableWeight = newValue;
                                               setRows(updatedRows);

                                               let chargeableWeight = updatedRows.reduce((acc, r) => acc + (parseFloat(r.chargeableWeight) || 0), 0);
                                               chargeableWeight = chargeableWeight.toFixed(2);
                                                setTotalCWHouses(chargeableWeight);
                                             }}
                                           />
                                            {rowFieldErrors[index]?.chargeableWeight && <small className="text-danger">Campo obligatorio</small>}
                                        </td>
                                        <td>
                                            <input
                                              type="number"
                                              step="any"
                                              className="form-control hbs_volume"
                                              value={row.volumen}
                                              onChange={(e) => {
                                                const newValue = e.target.value;
                                                const updatedRows = [...rows];
                                                updatedRows[index].volumen = newValue;
                                                setRows(updatedRows);

                                                let volumen = updatedRows.reduce(
                                                  (acc, r) => acc + (parseFloat(r.volumen) || 0),
                                                  0
                                                );
                                                volumen = volumen.toFixed(2);
                                                setTotalVolumenHouses(volumen);
                                              }}
                                            />
                                            {rowFieldErrors[index]?.volumen && <small className="text-danger">Campo obligatorio</small>}
                                        </td>
                                        <td>
                                            <select 
                                                className="form-select hbs_merchandiseType" 
                                                value={row.tipoMercancia} 
                                                onChange={(e) => {
                                                    const updatedRows = [...rows];
                                                    updatedRows[index].tipoMercancia = e.target.value;
                                                    setRows(updatedRows);
                                                }}
                                            >
                                            <option value="">Selecciona...</option>
                                                {Array.isArray(masterData?.data?.merch_type_con)
                                                  ? masterData.data.merch_type_con.map((item) => (
                                                      <option key={item.id} value={item.id}>
                                                        {item.name}
                                                      </option>
                                                    ))
                                                  : Object.entries(masterData?.data?.merch_type_con || {}).map(([key, label]) => (
                                                      <option key={key} value={key}>
                                                        {label}
                                                      </option>
                                                    ))}
                                            </select>
                                            {rowFieldErrors[index]?.tipoMercancia && <small className="text-danger">Campo obligatorio</small>}
                                        </td>
                                        <td>
                                            <input type="text" className="form-control hbs_description" value={row.descripcion} 
                                                onChange={(e) => {
                                                    const updatedRows = [...rows];
                                                    updatedRows[index].descripcion = e.target.value;
                                                    setRows(updatedRows);
                                                }} 
                                            />
                                        </td>
                                        <td className="text-center">
                                            <FaTrashAlt className='deleteButton' onClick={() => removeRow(index)} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="text-center mt-3">
                            <button className='btnn' style={{fontSize: '26px', padding: '0px 20px'}} onClick={addRow}>+</button>
                        </div>
                        {rowErrors && (
                            <div className="text-danger text-center mt-2">
                                {rowErrors}
                            </div>
                        )}
                    </div>
                )}
                {errorPesoPiezas && (
                    <div className="alert alert-danger text-danger text-center mt-2">
                        Error, la suma de las piezas, peso, peso cobrable y volumen de las houses deben coincidir con la master, favor de corroborar
                    </div>
                )}

                <div className="row">
                    <div className="col mt-4 d-flex justify-content-end gap-3">
                        <button className='btnn' onClick={handleSave} >Guardar</button>
                        <button className='btnn' onClick={handleCloseMaster} >Cerrar master</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CaptureForm;